var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { hairline } from '../../Theme';
import { Text, View } from 'elements/index';
import { T } from 'helpers/i18n';
import { toMoneyDecimal } from 'helpers/Format';
import { Input } from 'reactstrap';
import { PaymentMethod } from '../../Models/TicketPayment';
import Touchable from '../../elements/Touchable';
let Payments = class Payments extends Component {
    constructor() {
        super(...arguments);
        this.refCard = React.createRef();
        this.refDefer = React.createRef();
        this.refCredit = React.createRef();
        this.refTransf = React.createRef();
        this.refOther = React.createRef();
        this.handleTouchable = (input) => {
            var _a;
            console.log('input: ', input);
            (_a = input === null || input === void 0 ? void 0 : input.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
        this.onClearInput = (event, ref) => {
            ref.current.value = '';
            // event.currentTarget.value = ''
        };
    }
    componentDidMount() {
        // this.refOther.focus()
    }
    render() {
        const { moneyName, errorTotal, afiliateSelected, enablePaymentCredit, tempSale, handleInputMethod, handleAllMoneyClick } = this.props;
        return (React.createElement(View, { flex: true, style: Object.assign(Object.assign({}, hairline.top), { height: errorTotal ? 110 : 60, flex: 3, justifyContent: 'space-around', marginTop: '25px' }) },
            React.createElement(View, { flex: true, row: true, style: { justifyContent: 'space-around' } },
                React.createElement(PaymentMethodView, { method: PaymentMethod.Due, onHandleClick: () => { }, enabled: true, selected: tempSale.totalDue > 0, title: T(PaymentMethod.Due), value: tempSale.totalDue, moneyName: moneyName, refInput: this.refDefer, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick }),
                React.createElement(PaymentMethodView, { method: PaymentMethod.Cash, disabledInput: true, onHandleClick: () => { }, enabled: true, selected: tempSale.totalCash > 0, title: T(PaymentMethod.Cash), value: tempSale.totalCash, moneyName: moneyName, refInput: null, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick }),
                React.createElement(PaymentMethodView, { method: PaymentMethod.Card, onHandleClick: () => { }, enabled: true, selected: tempSale.totalCard > 0, title: T(PaymentMethod.Card), value: tempSale.totalCard, moneyName: moneyName, refInput: this.refCard, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick }),
                React.createElement(PaymentMethodView, { method: PaymentMethod.Credit, onHandleClick: () => { }, enabled: afiliateSelected, selected: tempSale.totalCredit > 0, title: T('credit'), value: tempSale.totalCredit, moneyName: moneyName, refInput: this.refCredit, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick }),
                React.createElement(PaymentMethodView, { method: PaymentMethod.Transfer, onHandleClick: () => { }, enabled: true, selected: tempSale.totalTransfer > 0, title: T('transfer'), value: tempSale.totalTransfer, moneyName: moneyName, refInput: this.refTransf, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick }),
                React.createElement(PaymentMethodView, { method: PaymentMethod.Other, onHandleClick: () => { }, enabled: true, selected: tempSale.totalOther > 0, title: T('other'), value: tempSale.totalOther, moneyName: moneyName, refInput: this.refOther, onClearInput: this.onClearInput, onHandleInput: handleInputMethod, onHandleAllMoneyClick: handleAllMoneyClick })),
            errorTotal && React.createElement(View, { center: true },
                React.createElement(Text, { primary: true }, "La suma de los pagos es superior al importe del ticket"))));
    }
};
Payments = __decorate([
    observer
], Payments);
export default Payments;
export const PaymentMethodView = ({ method, enabled, disabledInput, title, selected, refInput, value, moneyName, small, onHandleAllMoneyClick, onHandleInput, onClearInput }) => {
    const _disabledInput = disabledInput === undefined ? false : disabledInput;
    let defer = false;
    if (method === PaymentMethod.Due) {
        defer = value > 0 && method === PaymentMethod.Due;
    }
    if (enabled) {
        return (React.createElement("div", { style: { width: '100%' } },
            React.createElement(Touchable, { disabled: !enabled, onClick: () => {
                    if (onHandleAllMoneyClick) {
                        onHandleAllMoneyClick(method);
                    }
                }, style: Object.assign({ marginBottom: 0, backgroundColor: selected ? 'green' : undefined }, styleButtonPayment(selected)) }, title),
            React.createElement(Input, { disabled: _disabledInput, style: {
                    backgroundColor: _disabledInput ? 'white' : undefined,
                    borderWidth: _disabledInput ? 0 : undefined
                }, innerRef: refInput, name: method, onBlur: (event) => {
                    onHandleInput(event, refInput);
                    onClearInput(event, refInput);
                }, onKeyPress: (event) => {
                    if (event.charCode === 13) {
                        onHandleInput(event, refInput);
                        onClearInput(event, refInput);
                    }
                } }),
            React.createElement(Text, { small: small, style: {
                    textAlign: 'center',
                    margin: 0,
                    padding: 0,
                    backgroundColor: defer ? 'red' : undefined,
                    color: defer ? 'white' : undefined,
                } }, `${toMoneyDecimal(value, moneyName)}`)));
    }
    return null;
};
const styleButtonPayment = (selected) => {
    return {
        borderWidth: selected ? 1 : 0,
        borderRadius: selected ? 5 : 0,
        borderColor: 'white',
        backgroundColor: selected ? 'green' : undefined,
        color: selected ? 'white' : undefined
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/Payments.tsx
// module id = 112
// module chunks = 0